// Why the home screen preview and the real app do not match.
//
// The preview draws every configured button in order. The app decides at run
// time what to actually render, using data the admin cannot see — today's
// scores, whether a carousel has images, which tenant it is. So the preview is
// a guide to ORDER and PROPORTION, and cannot be a mirror.
//
// Each entry is written for the person arranging the buttons, not for a
// developer, and every one is a real difference traced to the fan app:
//   team_app_react_native/src/screens/HomeScreen/HomeScreen.js
//   team_app_react_native/src/components/{LeagueScores,Standings}Module.js

export const PREVIEW_DIFFERENCES = [
    {
        title: 'Modules only appear when they have something to show',
        detail: 'League Scores, Standings, Schedule, Player Leaders and Roster each disappear entirely on nights when they have no rows — no heading, no empty state, nothing. The preview always draws them, because it cannot know what today holds.',
        affects: ['isLeagueScoresModule', 'isStandingsModule', 'isScheduleModule', 'isPlayerLeadersModule', 'isRosterModule', 'isSeasonGamesModule']
    },
    {
        title: 'The carousel disappears when it has no images',
        detail: 'Top Carousel shows nothing at all if no carousel images are set up. Add them on the Top Carousel screen.',
        affects: ['isSlider']
    },
    {
        title: 'The scoreboard only moves once fans have the next app release',
        detail: 'Older versions of the app keep the scoreboard at the top of the Home screen no matter where it sits in this list; the next release puts it where you placed it. Hide Scoreboard in Settings hides it everywhere, including from the spot chosen here.',
        affects: ['isScoreboardModule']
    },
    {
        title: 'A button with no action never reaches fans',
        detail: 'The app only shows a button when it knows what tapping it should do. If a button was saved without choosing that, it sits in this list and in the preview, but no fan ever sees it.',
        affects: []
    }
];

// Does a given button type have a caveat worth flagging on its own card?
export function differenceFor(buttonType) {
    if (!buttonType) return null;
    return PREVIEW_DIFFERENCES.find(d => d.affects.indexOf(buttonType) !== -1) || null;
}
